import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalization } from 'Douleutaras/hooks/localization';

import { formatPrice } from './priceFormatter';
import { ServicePrice as ServicePriceData } from './types';
import './ServicePrice.scss';

interface ServicePriceProps {
  price?: ServicePriceData;
  className?: string;
}

/**
 * Renders a service's formatted price plus the `+ ΦΠΑ` ("+ VAT") subline.
 * Renders nothing when the price cannot be formatted (the row shows label-only).
 */
export const ServicePrice = ({ price, className }: ServicePriceProps) => {
  const { t } = useTranslation();
  const { formatter } = useLocalization();

  const formatted = formatPrice(price, { formatter, t });

  if (!formatted) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return (
    <span className={className} styleName="service-price">
      <span styleName="service-price__amount">{formatted}</span>
      <span styleName="service-price__vat">{t('T.PROS-PROFILE.SERVICES.VAT-SUFFIX')}</span>
    </span>
  );
};

export default ServicePrice;
